export const getFormattedValidationErrorFromAction = (action) => {
  const {
    response: {
      data: { errors = null, messages = null } = null,
      status: statusCode
    }
  } = action.error
  const getFirstOnly = (array, param) => ((array && array.length > 0 && array[0][param]))
  const messageError = getFirstOnly(errors, 'message') || getFirstOnly(messages, 'description') || ''
  const subMessageError = getFirstOnly(errors, 'subMessage') || ''
  const code = getFirstOnly(errors, 'code') || ''
  const subs = getFirstOnly(errors, 'sub') || []
  const errorData = {
    code,
    message: messageError,
    subMessage: subMessageError,
    subs,
    subSkus: subs.filter(s => s.type === code).map(s => s.message),
    statusCode
  }
  return errorData
}



// WEBPACK FOOTER //
// ./src/Shared/Util/index.js